import { Link } from "gatsby";
import Layout from "../components/layout";
import SEO from "../components/seo";
import React from "react";
import Img from "gatsby-image";
var EditionMakroskopPage = function EditionMakroskopPage(_ref) {
    var data = _ref.data;
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(SEO, {
        title: "Edition MAKROSKOP"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "border-t-8 border-solid border-makroOrange pb-8"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-xl lg:text-2xl text-makroOrange uppercase"
    }, data.datoCmsGfkEditionMakroskop.title), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap pb-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full sm:w-1/3"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "w-full sm:w-2/3 sm:pl-2 content-text"
    }, /*#__PURE__*/ React.createElement("div", {
        dangerouslySetInnerHTML: {
            __html: data.datoCmsGfkEditionMakroskop.text
        },
        style: {
            maxWidth: "620px"
        }
    }))), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: "pt-10 pb-5 h0 text-2xl lg:text-3xl"
    }, "Woran Wirtschaftspolitik scheitert. \xDCber M\xE4rkte, Hierarchien und Ungleichheit."), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full sm:w-1/3 sm:pr-6 pb-6"
    }, /*#__PURE__*/ React.createElement("img", {
        src: "/books/spatz-2026.jpg",
        alt: "Woran Wirtschaftspolitik scheitert von Alexander Mosca Spatz"
    }), /*#__PURE__*/ React.createElement(Link, {
        to: "/webshop/",
        className: "edition-makroskop-buy-button"
    }, "IM WEBSHOP ANSEHEN")), /*#__PURE__*/ React.createElement("div", {
        className: "w-full sm:w-2/3 content-text px-8 pt-6 pb-2 bg-makroGreyLight"
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            maxWidth: "620px"
        }
    }, /*#__PURE__*/ React.createElement("p", null, "Promedia 2026. ca. 256 S. 14,8 x 21. brosch."), /*#__PURE__*/ React.createElement("p", null, "Print: \u20AC 24,00. ISBN: 978-3-85371-565-9.", /*#__PURE__*/ React.createElement("br", null), "E-Book: \u20AC 19,99. ISBN: 978-3-85371-946-6."), /*#__PURE__*/ React.createElement("p", null, "Die liberalen Demokratien unserer Zeit stehen unter Druck. Sie wirken unf\xE4hig, die gro\xDFen Krisen unserer Gegenwart l\xF6sen zu k\xF6nnen \u2013 vom Klimawandel \xFCber die Gefahr finanzieller Zusammenbr\xFCche bis hin zur wachsenden sozialen Ungleichheit."), /*#__PURE__*/ React.createElement("p", null, "\u201EWoran Wirtschaftspolitik scheitert\u201C wendet sich sowohl gegen libert\xE4re Utopien einer v\xF6llig entfesselten Marktwirtschaft als auch gegen linke Deutungen, die jede Form von Ungleichheit als Ausbeutung brandmarken. Beide verkennen die komplexen Mechanismen moderner \xD6konomien."), /*#__PURE__*/ React.createElement("p", null, "Im Zentrum des Buches steht eine Analyse der inneren Struktur von M\xE4rkten als Netzwerke voller Hierarchien, Machtbeziehungen und potenzieller Instabilit\xE4ten. Darauf aufbauend werden die Ursachen und Folgen von Ungleichheit beleuchtet und politische Wege aufgezeigt, wie Leistungsgerechtigkeit von struktureller Ungerechtigkeit getrennt werden kann."), /*#__PURE__*/ React.createElement("p", null, "Im Schlussteil entwickelt der Autor \u2013 aufbauend auf keynesianischen und schumpeterianischen Einsichten \u2013 konkrete Reformvorschl\xE4ge: F\xFCr eine Wirtschaftspolitik, die Innovation erm\xF6glicht, soziale Mobilit\xE4t st\xE4rkt und demokratische Stabilit\xE4t sichert."), /*#__PURE__*/ React.createElement("p", null, /*#__PURE__*/ React.createElement("strong", null, "Der Autor")), /*#__PURE__*/ React.createElement("p", null, "Alexander Mosca Spatz, 1994 in N\xFCrnberg geboren, lebt in Aschaffenburg. Er studierte Wirtschaftswissenschaften an der Universit\xE4t W\xFCrzburg und der Otto-Friedrich-Universit\xE4t Bamberg. Seit 2022 arbeitet er als Volkswirt, zun\xE4chst in der Unternehmensberatung, seit 2024 in der Strategie und Unternehmensentwicklung einer Landesbausparkasse. Er ist gemeinsam mit Heiner Flassbeck Co-Autor des Buches \u201EGrundlagen einer relevanten \xD6konomik\u201C."))))), data.datoCmsGfkEditionMakroskop.books.map(function (b, i) {
        return /*#__PURE__*/ React.createElement("div", {
            key: i
        }, /*#__PURE__*/ React.createElement("div", {
            className: "pt-10 pb-5 h0 text-2xl lg:text-3xl"
        }, b.title), /*#__PURE__*/ React.createElement("div", {
            className: "flex flex-wrap"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "w-full sm:w-1/3 sm:pr-6 pb-6"
        }, b.image && /*#__PURE__*/ React.createElement(Img, {
            fluid: b.image.fluid
        }), /*#__PURE__*/ React.createElement("a", {
            href: '/webshop'
            /*b.link!*/
            ,
            target: "_blank",
            rel: "noreferrer",
            className: "edition-makroskop-buy-button"
        }, "ZUM WEBSHOP")), /*#__PURE__*/ React.createElement("div", {
            className: "w-full sm:w-2/3 content-text px-8 pt-6 pb-2 bg-makroGreyLight"
        }, /*#__PURE__*/ React.createElement("div", {
            dangerouslySetInnerHTML: {
                __html: b.text
            },
            style: {
                maxWidth: "620px"
            }
        }))));
    })));
};
var query = "4111966629";
export default EditionMakroskopPage;
